import React, { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import ChangeRequestAccordion from "../../Components/ChangeRequest/accordion";
import SweetAlert from "react-bootstrap-sweetalert";
import Button from "@mui/material/Button";
import TextEditor from "../../Components/casp/common/TextEditor";

import { toast } from "react-toastify";
import { getProjectDetails } from "../../api/casp/project";
import Loader from "../../Components/Common/Loader";
import {
  changeRequestCreate,
  changeRequestStatusUpdate,
} from "../../api/casp/changeRequest";
import { changeRequestItemCreate } from "../../api/casp/changeRequestItem";
import { Spinner } from "reactstrap";
import { Action } from "../../constants/Common";
import ChangeRequestMeta from "../../Components/ChangeRequest/changeRequestMeta";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { withTranslation } from "react-i18next";
import UserProfile from "../../Components/casp/common/userProfile";
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import NotFound from "../../Components/Common/PageNotFound";


const MainContent = (props) => {
  const loggedInUser = useSelector((state) => state.Profile.user);
  const [isLoading, setIsLoading] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [refreshComponentKeyOthers, setRefreshComponentKeyOthers] = useState({
    other: +new Date() + 'other',
  })
  const [isLoadingForButtons, setIsLoadingForButtons] = useState(false);
  const [projectDetails, setProjectDetails] = useState();
  const [changeRequestMetaInfo, setChangeRequestMetaInfo] = useState({
    description: "",
    reason: "",
    impact: "",
    comments: "",
    negativeImpact: "",
    priority: {},
  });
  const [changeRequestIsValid, setChangeRequestIsValid] = useState(false);
  const [itemPayload, setItemPayload] = useState([]);
  const [refresh, setRefresh] = useState(new Date());
  const navigate = useNavigate();

  useEffect(() => {
    if (props.projectId) {
      fetchProjectDetails();
    }
  }, []);

  const fetchProjectDetails = async () => {
    try {
      setIsLoading(true);
      const project = await getProjectDetails(props.projectId);
      setProjectDetails(project.data.data);
    } catch (error) {
      console.log(error);
      toast.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCreate = async (action) => {
    try {
      if (!itemPayload.length) {
        return toast.error("You need to introduce at least one module change!");
      }

      let changeRequestPayload = {
        projectId: props.projectId,
        description: changeRequestMetaInfo.description,
        reason: changeRequestMetaInfo.reason,
        impact: changeRequestMetaInfo.impact,
        negativeImpact: changeRequestMetaInfo.negativeImpact,
        ...(changeRequestMetaInfo.comments &&
          changeRequestMetaInfo.comments !== "" && {
          comments: changeRequestMetaInfo.comments,
        }),
        priorityId: changeRequestMetaInfo?.priority?.id,
      };

      setIsLoadingForButtons(true);
      const response = await changeRequestCreate(changeRequestPayload);

      if (response.statusCode === 200) {
        let changeRequestItemPayload = {
          projectId: props.projectId,
          changeRequestId: response.data.data.id,
          items: itemPayload,
        };
        await changeRequestItemCreate(changeRequestItemPayload);
        if (action === Action.SUBMIT) {
          const res = await changeRequestStatusUpdate(response.data.data.id, {
            projectId: props.projectId,
          });
          toast.success(res.data.message);
          navigate(`/project/${props.projectId}/change-request/${response.data.data.id}/details`);
        } else {
          toast.success(response.data.message);
          navigate(`/project/${props.projectId}/change-request/${response.data.data.id}/details`);
        }
      } else {
        toast.error(response.data.message);
      }
    } catch (err) {
      toast.error(err.message);
      console.log("161=>", err);
    } finally {
      setIsLoadingForButtons(false);
    }
  };

  const handleBackClick = () => {
    navigate(-1); //navigate to back page
  };

  return (
    <div className="changeReqMainContent projectInfo" key={refresh}>
      {projectDetails && !isLoading && (
        <div>
          <div className="d-flex align-items-center mb-3">
            <ArrowBackOutlinedIcon className="me-2 cursor-pointer" onClick={handleBackClick} />
            {projectDetails.name}
          </div>
          {!props.alreadyCreated ?
            <>
            <Card className="customCard changeReqCard portfolio-det mb-3 viewProjectApproval">
              <div className="d-grid threeColumns fourColumnsCR">
                {/* <div className="col-md-4"> */}
                <div className="wrap_box wrap_porfolio projDetailsListing flex-column">
                  <div className="mainUserName d-flex">
                    <span style={{ backgroundColor: '#C9F8FF' }} className='dashboardProjectIcon'>
                      <svg width="12" height="12" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3.33333 2V0H6V2H3.33333ZM0 3.33333V0H2.66667V3.33333H0ZM3.33333 6V2.66667H6V6H3.33333ZM0 6V4H2.66667V6H0Z" fill="#1195A9" />
                      </svg>
                    </span>&nbsp;
                    <span>{props.t('Incubator')}</span>
                  </div>
                  <div className="owner_detail d-flex align-items-center">
                    {/* <UserProfile user={projectDetails?.portfolioProjects[0].portfolio} profileClassName="profile_picture" /> */}
                    <div className="mx-2">
                      <div>
                        <span className="userName">
                          {projectDetails.portfolioProjects[0].portfolio.name}
                        </span>{" "}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="wrap_box wrap_porfolio projDetailsListing flex-column">
                  <div className="mainUserName d-flex">
                  <span style={{ backgroundColor: '#E5D1FF' }} className='dashboardProjectIcon'>
                      <svg width="12" height="12" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3.5 3C3.0875 3 2.73438 2.85313 2.44063 2.55938C2.14688 2.26562 2 1.9125 2 1.5C2 1.0875 2.14688 0.734375 2.44063 0.440625C2.73438 0.146875 3.0875 0 3.5 0C3.9125 0 4.26562 0.146875 4.55937 0.440625C4.85313 0.734375 5 1.0875 5 1.5C5 1.9125 4.85313 2.26562 4.55937 2.55938C4.26562 2.85313 3.9125 3 3.5 3ZM0.5 6V4.95C0.5 4.7375 0.554688 4.54219 0.664063 4.36406C0.773438 4.18594 0.91875 4.05 1.1 3.95625C1.4875 3.7625 1.88125 3.61719 2.28125 3.52031C2.68125 3.42344 3.0875 3.375 3.5 3.375C3.9125 3.375 4.31875 3.42344 4.71875 3.52031C5.11875 3.61719 5.5125 3.7625 5.9 3.95625C6.08125 4.05 6.22656 4.18594 6.33594 4.36406C6.44531 4.54219 6.5 4.7375 6.5 4.95V6H0.5Z" fill="#803DD7" />
                      </svg>
                    </span>&nbsp;
                    <span>{props.t('Manager')}</span>
                  </div>
                  <div className="owner_detail d-flex align-items-center mt-1">
                    <UserProfile user={projectDetails?.portfolioProjects[0].portfolio.assignee} />
                    <div className="mx-2">
                      <div>
                        <span className="userName">
                          {projectDetails.portfolioProjects[0].portfolio.assignee.name}
                        </span>{" "}
                      </div>
                    </div>
                  </div>
                </div>
                {/* </div>
                <div className="col-md-4"> */}
                <div className="wrap_box wrap_owner projDetailsListing flex-column">
                  <div className="mainUserName d-flex">
                    <span style={{ backgroundColor: '#E5D1FF' }} className='dashboardProjectIcon'>
                      <svg width="12" height="12" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3.5 3C3.0875 3 2.73438 2.85313 2.44063 2.55938C2.14688 2.26562 2 1.9125 2 1.5C2 1.0875 2.14688 0.734375 2.44063 0.440625C2.73438 0.146875 3.0875 0 3.5 0C3.9125 0 4.26562 0.146875 4.55937 0.440625C4.85313 0.734375 5 1.0875 5 1.5C5 1.9125 4.85313 2.26562 4.55937 2.55938C4.26562 2.85313 3.9125 3 3.5 3ZM0.5 6V4.95C0.5 4.7375 0.554688 4.54219 0.664063 4.36406C0.773438 4.18594 0.91875 4.05 1.1 3.95625C1.4875 3.7625 1.88125 3.61719 2.28125 3.52031C2.68125 3.42344 3.0875 3.375 3.5 3.375C3.9125 3.375 4.31875 3.42344 4.71875 3.52031C5.11875 3.61719 5.5125 3.7625 5.9 3.95625C6.08125 4.05 6.22656 4.18594 6.33594 4.36406C6.44531 4.54219 6.5 4.7375 6.5 4.95V6H0.5Z" fill="#803DD7" />
                      </svg>
                    </span>&nbsp;
                    <span>{props.t('Owner')}</span>
                  </div>
                  <div className="owner_detail d-flex align-items-center mt-1">
                    <UserProfile user={projectDetails?.projectOwner}  />
                    <div className="mx-2">
                      <div>
                        <span className="userName">
                          {projectDetails.projectOwner.name}
                        </span>{" "}
                      </div>
                    </div>
                  </div>
                </div>
                {/* </div> */}
                {/* <div className="col-md-4"> */}
                <div className="wrap_box wrap_sponsor projDetailsListing flex-column">
                  <div className="mainUserName d-flex">
                    <span style={{ backgroundColor: '#D6FFAD' }} className='dashboardProjectIcon'>
                      <svg width="14" height="12" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.25 6V4.95C0.25 4.7375 0.30303 4.54219 0.409091 4.36406C0.515152 4.18594 0.656061 4.05 0.831818 3.95625C1.20758 3.7625 1.58939 3.61719 1.97727 3.52031C2.36515 3.42344 2.75909 3.375 3.15909 3.375C3.55909 3.375 3.95303 3.42344 4.34091 3.52031C4.72879 3.61719 5.11061 3.7625 5.48636 3.95625C5.66212 4.05 5.80303 4.18594 5.90909 4.36406C6.01515 4.54219 6.06818 4.7375 6.06818 4.95V6H0.25ZM6.79545 6V4.875C6.79545 4.6 6.72121 4.33594 6.57273 4.08281C6.42424 3.82969 6.21364 3.6125 5.94091 3.43125C6.25 3.46875 6.54091 3.53281 6.81364 3.62344C7.08636 3.71406 7.34091 3.825 7.57727 3.95625C7.79545 4.08125 7.96212 4.22031 8.07727 4.37344C8.19242 4.52656 8.25 4.69375 8.25 4.875V6H6.79545ZM3.15909 3C2.75909 3 2.41667 2.85313 2.13182 2.55938C1.84697 2.26562 1.70455 1.9125 1.70455 1.5C1.70455 1.0875 1.84697 0.734375 2.13182 0.440625C2.41667 0.146875 2.75909 0 3.15909 0C3.55909 0 3.90152 0.146875 4.18636 0.440625C4.47121 0.734375 4.61364 1.0875 4.61364 1.5C4.61364 1.9125 4.47121 2.26562 4.18636 2.55938C3.90152 2.85313 3.55909 3 3.15909 3ZM6.79545 1.5C6.79545 1.9125 6.65303 2.26562 6.36818 2.55938C6.08333 2.85313 5.74091 3 5.34091 3C5.27424 3 5.18939 2.99219 5.08636 2.97656C4.98333 2.96094 4.89849 2.94375 4.83182 2.925C4.99545 2.725 5.12121 2.50312 5.20909 2.25938C5.29697 2.01562 5.34091 1.7625 5.34091 1.5C5.34091 1.2375 5.29697 0.984375 5.20909 0.740625C5.12121 0.496875 4.99545 0.275 4.83182 0.075C4.91667 0.04375 5.00152 0.0234375 5.08636 0.0140625C5.17121 0.0046875 5.25606 0 5.34091 0C5.74091 0 6.08333 0.146875 6.36818 0.440625C6.65303 0.734375 6.79545 1.0875 6.79545 1.5Z" fill="#4E9903" />
                      </svg>
                    </span>&nbsp;
                    <span>{props.t('Sponsor')}</span>
                  </div>
                  <div className="owner_detail d-flex align-items-center mt-1">
                    <UserProfile user={projectDetails?.projectSponsor} />
                    <div style={{ marginLeft: "10px" }}>
                      <div>
                        <span className="userName">
                          {projectDetails.projectSponsor.name}
                        </span>{" "}
                      </div>
                    </div>
                  </div>
                </div>
                {/* </div> */}
              </div>
            </Card>
            <Card className="customCard changeReqCard portfolio-det" style={{ padding: '15px' }}>
              <ChangeRequestMeta isLoading={isLoading} isLoadingForButtons={isLoadingForButtons} setChangeRequestMetaInfo={setChangeRequestMetaInfo} setChangeRequestIsValid={setChangeRequestIsValid} />

              {/* all modules div starts here */}
              <div className="allModules">
                <div className="allModuleHeading">{props.t('Select Module')}</div>
                <ChangeRequestAccordion
                  project={projectDetails}
                  setItemPayload={setItemPayload}
                  emit={(data) => {
                    setItemPayload(data);
                  }}
                />
              </div>

              {/* comment box starts here */}
              <div className="commentBox d-flex w-100 mt-3">
                <div>
                  <UserProfile user={loggedInUser} profileClassName="me-2 ml-2 profile_picture" avatarClassName="me-2 ml-2" />
                </div>
                <div className="flex-grow-1">
                  <TextEditor
                    key={refreshComponentKeyOthers.other}
                    content={""}
                    toolbarId={`toolbarCreateComment`}
                    placeholder={props.t('Others')}
                    name="comments"
                    isEmpty={false}
                    disabled={isLoading || isLoadingForButtons}
                    value={changeRequestMetaInfo.comments}
                    emitItem={(newValue) => {
                      const regex = /(<([^>]+)>)/gi;
                      const newString = newValue.replace(regex, "");
                      if (!newString.toString().trim()) {
                        return toast.error("comment is required");
                      } else if (newString.trim().length !== newString.length) {
                        setRefreshComponentKeyOthers((prev) => {
                          return { ...prev, other: +new Date() + 'other' }
                        })
                        return toast.error('Must not include leading and trailing spaces');
                      } else {
                        setChangeRequestMetaInfo({
                          ...changeRequestMetaInfo,
                          comments: newValue,
                        })
                      }
                    }}
                  />
                </div>
              </div>


              {/* actions here */}
              <div className="changeRequestActions d-flex justify-content-center plsubmitButton mt-3">
                <Button
                  className="submitBtn btn addNew_ProjectBtn addNew_outlined_ProjectBtn"
                  variant="outlined"
                  onClick={() => { setOpenAlert(true) }}
                >
                  {props.t('Cancel')}
                </Button>
                <Button
                  className={`mx-3 ${!changeRequestIsValid || isLoadingForButtons ? "submitBtn btn addNew_ProjectBtn addNew_outlined_ProjectBtn" : "create_req_theme"
                    }`}
                  variant="outlined"
                  disabled={isLoadingForButtons || !changeRequestIsValid}
                  onClick={handleCreate}
                >
                  {isLoading && (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-1"
                    />
                  )}
                  {props.t('Save As Draft')}
                </Button>
                <Button
                  className={`${!changeRequestIsValid || isLoadingForButtons ? "submitBtn btn addNew_ProjectBtn text-white" : "submitBtn btn addNew_ProjectBtn"
                    }`}
                  variant="contained"
                  disabled={isLoadingForButtons || !changeRequestIsValid}
                  onClick={() => handleCreate(Action.SUBMIT)}
                >
                  {isLoadingForButtons && (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-1"
                    />
                  )}
                  {props.t('Submit')}
                </Button>
              </div>
            </Card>
            </>
            :
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
              height: '100vh'
          }}>
              <p>{props.t('You cannot create a new change request until the existing one is approved')}</p>
            </div >
          }

          {/* <Card className="customCard changeReqCard p-3 my-3">
            <div className="impact d-flex flex-column position-relative">
              <label className="position-absolute abs-label">
                Describe the change *
              </label>
              <TextareaAutosize
                className="position-relative"
                minRows="2"
                name="description"
                disabled={isLoading || isLoadingForButtons}
                value={formik.values.description}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                required
              />
              {formik.touched.description && formik.errors.description && (
                <span className="text-danger">{formik.errors.description}</span>
              )}
            </div>
          </Card> */}

          {/* <Card className="customCard changeReqCard p-3 my-3">
            <div className="impact d-flex flex-column position-relative">
              <label className="position-absolute abs-label">
                Reason for the change *
              </label>
              <TextareaAutosize
                className="position-relative"
                minRows="2"
                name="reason"
                disabled={isLoading || isLoadingForButtons}
                value={formik.values.reason}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                required
              />
              {formik.touched.reason && formik.errors.reason && (
                <span className="text-danger">{formik.errors.reason}</span>
              )}
            </div>
          </Card> */}

          {/* <Card className="customCard changeReqCard p-3 my-3">
            <div className="impact d-flex flex-column position-relative">
              <label className="position-absolute abs-label">
                Impact for the change *
              </label>
              <TextareaAutosize
                className="position-relative"
                minRows="2"
                name="impact"
                disabled={isLoading || isLoadingForButtons}
                value={formik.values.impact}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                required
              />
              {formik.touched.impact && formik.errors.impact && (
                <span className="text-danger">{formik.errors.impact}</span>
              )}
            </div>
          </Card> */}

          {/* <Card className="customCard changeReqCard priority-level my-3">
            <SearchDropDownListPaginationComponent
              label="Select Priority Level *"
              required
              disabled={isLoadingForButtons || isLoading}
              searchEnabled={false}
              listCall={AllPriorityList}
              emitItem={(newValue) => {
                setNewChangeRequestObject({
                  ...newChangeRequestObject,
                  priority: newValue,
                });
                formik.setFieldValue("priority", newValue ? newValue : "");
              }}
              onBlur={() => {
                if (!formik.touched?.priority) {
                  formik.setFieldTouched("priority.id", true, true);
                }
              }}
            />
            {formik.touched.priority?.id && formik.errors.priority?.id && (
              <span className="text-danger">{formik.errors.priority.id}</span>
            )}
          </Card> */}

          {/* Select Module area starts */}
          {/* <Card className="customCard changeReqCard my-3">
            <div className="allModules p-3">
              <div className="allModuleHeading">{props.t('Select Module')}</div>
              <ChangeRequestAccordion
                project={projectDetails}
                setItemPayload={setItemPayload}
                emit={(data) => {
                  setItemPayload(data);
                }}
              />
            </div>
          </Card> */}

          {/* <Card className="customCard changeReqCard p-3 my-3">
            <div className="impact d-flex flex-column position-relative">
              <label className="position-absolute abs-label">
                Specify the impact if the change request is not approved *
              </label>
              <TextareaAutosize
                className="position-relative"
                minRows="2"
                name="negativeImpact"
                disabled={isLoading || isLoadingForButtons}
                value={formik.values.negativeImpact}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                required
              />
              {formik.touched.negativeImpact &&
                formik.errors.negativeImpact && (
                  <span className="text-danger">
                    {formik.errors.negativeImpact}
                  </span>
                )}
            </div>
          </Card> */}

          {/* <Card className="customCard changeReqCard p-3 my-3"> */}
          {/* <div className="commentBox d-flex w-100">
              <div>
                <UserProfile user={loggedInUser}  profileClassName="me-2 ml-2 profile_picture" avatarClassName="me-2 ml-2"/>
              </div>
              <div className="flex-grow-1">
                <TextEditor
                  key={refreshComponentKeyOthers.other}
                  content={""}
                  toolbarId={`toolbarCreateComment`}
                  placeholder={props.t('Others')}
                  name="comments"
                  isEmpty={false}
                  disabled={isLoading || isLoadingForButtons}
                  value={changeRequestMetaInfo.comments}
                  emitItem={(newValue) => {
                    const regex = /(<([^>]+)>)/gi;
                    const newString = newValue.replace(regex, "");
                    if (!newString.toString().trim()) {
                      return toast.error("comment is required");
                    } else if(newString.trim().length !== newString.length){
                      setRefreshComponentKeyOthers((prev) => {
                        return {...prev, other: +new Date() + 'other'}
                      })
                      return toast.error('Must not include leading and trailing spaces');
                    } else {
                      setChangeRequestMetaInfo({
                        ...changeRequestMetaInfo,
                        comments: newValue,
                      })
                    }
                  }}
                />
              </div>
            </div> */}
          {/* </Card> */}

          {/* <div className="changeRequestActions d-flex justify-content-center plsubmitButton">
            <Button
              className="submitBtn btn addNew_ProjectBtn text-white"
              variant="outlined"
              onClick={() => { setOpenAlert(true) }}
            >
              {props.t('Cancel')}
            </Button>
            <Button
              className={`mx-3 ${
                !changeRequestIsValid || isLoadingForButtons ? "btn btn-outline-secondary" : "create_req_theme"
              }`}
              variant="outlined"
              disabled={isLoadingForButtons || !changeRequestIsValid}
              onClick={handleCreate}
            >
              {isLoading && (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-1"
                />
              )}
              {props.t('Save As Draft')}
            </Button>
            <Button
              className={`${
                !changeRequestIsValid || isLoadingForButtons ? "btn btn-outline-secondary" : "create_req_success"
              }`}
              variant="contained"
              disabled={isLoadingForButtons || !changeRequestIsValid}
              onClick={() => handleCreate(Action.SUBMIT)}
            >
              {isLoadingForButtons && (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-1"
                />
              )}
              {props.t('Submit')}
            </Button>
          </div> */}
        </div>
      )}

      {isLoading && <Loader />}
      {openAlert && (<SweetAlert
        title={props.t("Any unsaved changes will be discard, Do you want to continue?")}
        warning
        showCancel
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="danger"
        onConfirm={() => {
          setOpenAlert(false)
          setRefresh(+new Date())
        }}
        onCancel={() => {
          setOpenAlert(false)
        }}>
      </SweetAlert>)}
    </div>
  );
}

export default withTranslation()(MainContent);
